module.exports = __webpack_public_path__ + "static/media/security.545a276f.png";